<!-- components/EditForm.vue -->
<template>
    <div class="edit-form">
        <div class="search-div">
            <el-input placeholder="请输入名称" v-model="input_userName">
            </el-input>
            <el-button type="primary" v-html="searchsvg" circle @click="click_search" class="yu-s"></el-button>
            <el-button type="primary" round @click="click_clear">清除</el-button>
        </div>
        <div v-if="ispermission == true" class="list-display-div">
            <el-table :data="user_group_data" style="width: 100%" max-height="250">
                <el-table-column fixed prop="Accounts" label="名称" :width="table_column_width[0]">
                </el-table-column>
                <el-table-column prop="Position" label="职务" :width="table_column_width[1]">
                </el-table-column>
                <el-table-column prop="Integral" label="积分" :width="table_column_width[2]">
                </el-table-column>
                <el-table-column v-show="ispermission" fixed="right" label="操作" :width="table_column_width[3]">
                    <template #default="{ row, $index }">
                        <div v-html="settingsvg" @click="setting_button($index, row)"></div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-else class="list-display-div">
            <el-table :data="user_group_data" style="width: 100%" max-height="250">
                <el-table-column fixed prop="Accounts" label="名称" :width="table_column_width[0]">
                </el-table-column>
                <el-table-column prop="Position" label="职务" :width="table_column_width[1]">
                </el-table-column>
                <el-table-column prop="Integral" label="积分" :width="table_column_width[2]">
                </el-table-column>
            </el-table>
        </div>

        <ModalEI v-if="showModal" v-model:visible="showModal" titleValue="操作" @close="showModal = false">
            <div>
                <el-button type="primary" @click="deleteRow">踢出成员</el-button>
                <el-button type="primary" v-show="rowData[1].Position == '成员'" @click="AppointmentP">任命职位</el-button>
                <el-button type="primary" v-show="rowData[1].Position == '管理'" @click="sack">撤去职位</el-button>
            </div>
        </ModalEI>

        <ModalEI v-if="showModalAppointmentP" v-model:visible="showModalAppointmentP" titleValue="选择职位"
            @close="showModalAppointmentP = false">
            <div>
                <div>当前同盟管理：</div>
                <el-button type="primary" @click="AppointmentButton_o" :disabled="isdisabled">管理一【{{ AdministratorOne }}】</el-button>
                <el-button type="primary" @click="AppointmentButton_t" :disabled="isdisabled">管理二【{{ AdministratorTwo }}】</el-button>
            </div>
        </ModalEI>
    </div>
</template>

<script>
import { svgRead } from '@/svgIcon/main';
import request from '@/utils/request' // 就写这一行

export default {
    name: 'GroupIntroduce',
    props: [],
    data() {
        return {
            input_userName: "",
            user_group_data: [],
            standard_table_column_width: [165, 95, 135, 135],
            ratio_table_column_width: [11, 6, 9, 9],
            standard_table_column_width_cy: [210, 140, 180, 0],
            ratio_table_column_width_cy: [14, 9, 12, 0],
            table_column_width: [],
            ratio: 35,
            ispermission: false,
            searchsvg: svgRead('search-a', "#FFFFFF"),
            settingsvg: svgRead('setting-a', null, 20, 20),
            showModal: false,
            rowData: [],
            showModalAppointmentP: false,
            AdministratorTwo: "查询中...",
            AdministratorOne: "查询中...",
            isdisabled: true
        }
    },
    methods: {
        close() {
            this.$emit('close');
        },
        click_clear() {
            this.input_userName = "";
            // this.user_group_data = [];
            this.ObtainData();
        },
        async click_search() {
            if (this.input_userName.replace(/\s+/g, '') == "" || this.input_userName == null) {
                this.$messageX.xiaoxiti("e", "请先输入玩家名称！");
                this.input_userName = "";
                return;
            }
            try {
                const res = await request.post('/SearchAllianceMember', {
                    userName: this.input_userName
                });

                this.$messageX.xiaoxiti("c", res.message);
                this.user_group_data = [res.response];
            } catch (err) {
                console.log('搜索失败:', err);
                this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
            }
        },
        /**
         * 踢出成员
         */
        async deleteRow() {
            if (this.rowData == []) {
                this.$messageX.xiaoxiti("e", "系统运行出现错误！请联系管理员！【错误编码< qjs0002 >】");
                return;
            }
            // const index = this.rowData[0];
            const rows = this.rowData[1];
            try {
                const res = await request.post('/RemoveMember', {
                    userName: rows.Accounts
                });

                this.$messageX.xiaoxiti("c", res.message);
                this.ObtainData();
            } catch (err) {
                console.log('操作失败:', err);
                this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
            }
        },
        /**
         * 任命职务
         */
        async Appointment() {
            if (this.rowData == []) {
                this.$messageX.xiaoxiti("e", "系统运行出现错误！请联系管理员！【错误编码< qjs0002 >】");
                return;
            }
            // const index = this.rowData[0];
            const rows = this.rowData[1];
            try {
                const res = await request.post('/Appointment', {
                    userName: rows.Accounts,
                    setPosition: this.rowData[2]
                });

                this.$messageX.xiaoxiti("c", res.message);
                // this.showModalAppointmentP = false;
                this.showModal = false;
                this.ObtainData();
            } catch (err) {
                console.log('操作失败:', err);
                this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
            }
        },
        /**
         * 获取数据
         */
        async ObtainData() {
            try {
                const res = await request.post('/ObtainAllianceMember', {
                });

                // this.$messageX.xiaoxiti("c", res.message);
                this.user_group_data = res.response;
            } catch (err) {
                console.log('获取失败:', err);
                this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
            }
        },
        handleResize() {
            const width = window.innerWidth;
            const height = window.innerHeight;

            // 1. 先清空或重置数组，防止长度不一致导致的残留
            this.table_column_width = [];

            // 2. 确定使用哪套配置
            const standardWidths = this.ispermission ? this.standard_table_column_width : this.standard_table_column_width_cy;
            const ratioWidths = this.ispermission ? this.ratio_table_column_width : this.ratio_table_column_width_cy;

            if (width > height) {
                // 横屏：直接使用标准宽度
                this.table_column_width = [...standardWidths]; // 复制数组
            } else {
                // 竖屏：计算比例宽度
                // 使用 let 替代 var
                let calculatedWidth = width / (this.ratio / 100);
                calculatedWidth = Math.floor(calculatedWidth); // 使用 Math.floor 替代 split

                // 使用 map 替代 for 循环，代码更函数式
                this.table_column_width = ratioWidths.map(ratio => {
                    return calculatedWidth * (ratio / 100) - 15;
                });
            }
        },
        setting_button(index, rows) {
            this.showModal = true;
            this.rowData = [index, rows];
            console.table(this.rowData);
            if (!this.showModal) {
                this.deleteRow(index, rows);
                this.Appointment(index, rows);
                this.sack(index, rows);
            }

        },
        /**
         * 撤职
         */
        async sack() {
            // console.log("撤职");
            if (this.rowData == []) {
                this.$messageX.xiaoxiti("e", "系统运行出现错误！请联系管理员！【错误编码< qjs0002 >】");
                return;
            }
            const index = this.rowData[0];
            const rows = this.rowData[1];
            console.log(index, rows);
            try {
                const res = await request.post('/RemovePost', {
                    removePostUser: rows.Accounts
                });

                this.$messageX.xiaoxiti("c", res.message);
                this.showModal = false;
                this.ObtainData();
            } catch (err) {
                console.log('操作失败:', err);
                this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
            }
        },
        clearRowData() {
            this.rowData = [];
        },
        AppointmentP() {
            this.showModalAppointmentP = true;
        },
        /**
         * 获取同盟中职务任命状态
         */
        async obtainPosition() {
            try {
                const res = await request.post('/ObtainPosition', {
                });

                // this.$messageX.xiaoxiti("c", res.message);
                this.isdisabled = false;
                let a = res.response.AdministratorOne;
                if (a == null || a == "" || a.replace(/\s+/g, '') == "") {
                    res.response.AdministratorOne = "空闲...";
                }
                let b = res.response.AdministratorTwo;
                if (b == null || b == "" || b.replace(/\s+/g, '') == "") {
                    res.response.AdministratorTwo = "空闲...";
                }
                this.AdministratorOne = res.response.AdministratorOne;
                this.AdministratorTwo = res.response.AdministratorTwo;
            } catch (err) {
                console.log('获取失败:', err);
                this.$messageX.xiaoxiti("e", err.message || "查询服务异常");
                this.isdisabled = true;
            }
        },
        AppointmentButton_o(){
            if (this.AdministratorOne == "空闲..."){
                this.rowData.push("AdministratorOne");
                this.Appointment();
                this.showModalAppointmentP = false;
            }else{
                this.$messageX.xiaoxiti("w", "该职务已被授予！");
            }
        },
        AppointmentButton_t(){
            if (this.AdministratorTwo == "空闲..."){
                this.rowData.push("AdministratorTwo");
                this.Appointment();
                this.showModalAppointmentP = false;
            }else{
                this.$messageX.xiaoxiti("w", "该职务已被授予！");
            }
        }
    },
    mounted() {
        // 1. 绑定事件监听器
        this.table_column_width = this.standard_table_column_width;
        const storedData = JSON.parse(localStorage.getItem('userData'));
        // console.log('当前用户职位:', storedData?.user?.user?.Position);
        // console.log('设置权限前 ispermission:', this.ispermission);

        if (storedData.user.user.Position == "管理") {
            this.ispermission = true;
        }
        window.addEventListener('resize', this.handleResize);
        this.handleResize();
        this.ObtainData();
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        // 方法 1：直接监听变量名
        showModal(newVal, oldVal) {
            // console.log(`showModal 从 ${oldVal} 变成了 ${newVal}`);
            oldVal;
            // 在这里写你的业务代码
            if (newVal === false) {
                // 当弹窗打开时执行的代码
                this.clearRowData(); // 举例：获取数据
            }
        },
        showModalAppointmentP(newVal, oldVal) {
            // console.log(`showModalAppointmentP 从 ${oldVal} 变成了 ${newVal}`);
            oldVal;
            if (newVal === true) {
                this.obtainPosition();
            } else {
                this.isdisabled = true;
                this.AdministratorOne = "查询中...";
                this.AdministratorTwo = "查询中...";
            }
        }
    },
}
</script>

<style scoped>
.edit-form {
    display: block;
    margin-bottom: 10px;
    padding: 6px;
}

.search-div {
    display: flex;
    width: 100%;
    height: 40px;
    padding-right: 10px;
    flex-direction: row;
    flex-wrap: nowrap;
    align-content: center;
    align-items: center;
    justify-content: flex-end;
}

.list-display-div {
    width: 100%;
    height: calc(100% - 40px);
    padding: 10px;
    display: flex;
}

.yu-s {
    margin-left: 15px;
}
</style>